import { authApiHandler } from '../services/authApi'
import type { AuthConfig } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<string | null> => {
    const zendeskToken = cookies.getZendeskToken()
    const selectedContactId = cookies.getContactId()

    if (token.isValidZendeskToken(zendeskToken, selectedContactId)) {
      return zendeskToken
    }

    // The server route sets the cookie.
    if (typeof window !== 'undefined') {
      const result = await authApi.postAuthRoute<{ zendeskToken: string | null }>('zendesk')
      return result?.zendeskToken ?? null
    }

    return authApi.getZendeskToken(cookies.getIdToken(), selectedContactId)
  }
}
